import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseHeaderComponent } from './components';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { UtilsModule } from '@anecdotes/design-system/utils';

@NgModule({
  declarations: [
    BaseHeaderComponent,
  ],
  imports: [
    CommonModule,
    SvgIconsModule,
    ButtonsModule,
    NgbTooltipModule,
    DirectivesModule,
    UtilsModule,
  ],
  exports: [
    BaseHeaderComponent,
  ],
})
export class HeadersModule {}
